export interface Event {
  uuid: string;
  categoryUuid: string;
  done: boolean;
  date: string;
  color: string;
  label: string;
  value: string;
  reminder: string;
}

export interface Category {
  uuid: string;
  color: string;
  label: string;
  withReminder: boolean;
  withAttendance: boolean;
  descriptionTitle: string;
  descriptionText: string;
  reminders: Array<{ name: string; value: string }>;
  question: EventQuestion;
  value: string;
}

interface EventQuestion {
  withQuestion: boolean;
  options: Array<{ name: string; value: string }>;
  title: string;
}
